import { message } from 'antd';
import { AxiosError } from 'axios';

import { Links } from 'links';

import { ApiError } from 'codegen';

export const handleError = (error: AxiosError<ApiError>) => {
  const errorCode = error.response?.status;
  const errorCodes = [412, 501, 502];
  const CANCELED = error.code === 'ERR_CANCELED';

  if (!CANCELED && errorCodes.includes(errorCode as number)) {
    message.error(error.response?.data.message);
  }

  if (!CANCELED && errorCode === 403) {
    window.location.replace(Links.NoAccess);
  }

  if (!CANCELED && errorCode === 404) {
    window.location.replace(Links.NotFound);
  }

  return Promise.reject<AxiosError>(error);
};
